import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import MarkdownRender from '../MarkdownRender'

const ConfirmationBox = props => {
    return (
        <div>
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.message && props.message}
                        {props.noteMessage && (
                            <>
                                <br />
                                <br />
                                {props.noteMessage}
                            </>
                        )}
                        {props.markDownMessage && (
                            <MarkdownRender
                                value={props.markDownMessage}
                            ></MarkdownRender>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {props.rejectButton && (
                        <Button onClick={props.closeDialog} color="default">
                            {props.rejectButton}
                        </Button>
                    )}
                    {props.confirmButton && (
                        <Button onClick={props.confirmAction} color="primary" autoFocus>
                            {props.confirmButton}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ConfirmationBox
